import React from "react";

import ApproveIcon from "@material-ui/icons/Check";
import DenyIcon from "@material-ui/icons/Clear";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { StableEntryInfo } from "../ReviewFormPopup";
import { checkStableEntryStatus } from "../../helper";
import useStyles from "./styles";

interface IProps {
  stableEntries: StableEntryInfo[];
}

const StableEntriesDecisions = (props: IProps) => {
  const { stableEntries } = props;

  const classes = useStyles();

  const stableEntriesTotalCount = stableEntries.length;
  const stableEntriesApprovedCount = stableEntries.filter(
    entry =>
      entry.status ===
      racehorse360.StableEntryStatus.STABLE_ENTRY_STATUS_APPROVED
  ).length;

  const renderStableEntriesList = () => {
    return stableEntries.map((item, index) => {
      const { isDenied, isApproved } = checkStableEntryStatus(item.status);
      let decisionIcon;

      if (isApproved) {
        decisionIcon = <ApproveIcon className={classes.approveIcon} />;
      } else if (isDenied) {
        decisionIcon = <DenyIcon className={classes.denyIcon} />;
      }

      return (
        <div key={item.horseName + index} className={classes.stableEntryRow}>
          <span>{item.horseName}</span>
          {decisionIcon}
        </div>
      );
    });
  };

  return (
    <>
      <div className={classes.stableEntriesCount}>
        {`Stable Entries (${stableEntriesTotalCount}) // Approved (${stableEntriesApprovedCount})`}
      </div>
      <div className={classes.stableEntriesContainer}>
        {renderStableEntriesList()}
      </div>
    </>
  );
};

export default React.memo(StableEntriesDecisions);
